import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

/**
 * A term that has ended still leaves its periods committed, and a validity edit can reflow their
 * dates — so the warning follows the committed periods rather than the running term.
 */
export function isUnderCommitment(
  lock:
    | { isTermRunning: boolean; chainLockedPeriodIds: number[] }
    | null
    | undefined,
): boolean {
  return (
    lock?.isTermRunning === true || (lock?.chainLockedPeriodIds.length ?? 0) > 0
  );
}

export function CommitmentWarningDialog({
  isOpen,
  isSaving,
  consequence,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean;
  isSaving: boolean;
  /** What this particular change does to the term, when the caller can work it out. */
  consequence?: ReactNode;
  onDismiss: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onDismiss}
      isDismissable={!isSaving}
      isKeyboardDismissDisabled={isSaving}
      hideCloseButton={isSaving}
      size="md"
      data-identifier="commitment-warning-dialog"
    >
      <ModalContent>
        <ModalHeader>
          <Trans>Paket je v vezavi</Trans>
        </ModalHeader>
        <ModalBody>
          <p className="text-default-500 text-sm">
            <Trans>
              Stranka ima za ta paket sklenjeno vezavo. Želiš spremembo vseeno
              shraniti?
            </Trans>
          </p>
          {consequence}
        </ModalBody>
        <ModalFooter className="flex-col gap-2">
          <Button
            fullWidth
            color="primary"
            type="button"
            isLoading={isSaving}
            data-identifier="commitment-warning-confirm"
            onPress={onConfirm}
          >
            <Trans>Vseeno shrani</Trans>
          </Button>
          <Button
            fullWidth
            variant="light"
            type="button"
            isDisabled={isSaving}
            data-identifier="commitment-warning-cancel"
            onPress={onDismiss}
          >
            <Trans>Prekliči</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
